import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import { setLoading, setUser } from '../redux/slice/Authslice';

export const useAuth = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setLoading(true));

        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                try {
                    // Fetch role from Firestore so it's restored after every refresh
                    const userDocRef = doc(db, 'Users', firebaseUser.uid);
                    const userDoc = await getDoc(userDocRef);
                    const role = userDoc.exists() ? userDoc.data()?.role : null;
                    const userData = userDoc.exists() ? userDoc.data() : null;

                    dispatch(setUser({
                        uid: firebaseUser.uid,
                        email: firebaseUser.email,
                        displayName: (userData?.first_name || "") + " " + (userData?.last_name || ""),
                        photoURL: firebaseUser.photoURL,
                        role,
                    }));
                } catch (error) {
                    console.error('Error fetching user role on auth restore:', error);
                    // Still set user so the app doesn't break — role will be undefined
                    dispatch(setUser({
                        uid: firebaseUser.uid,
                        email: firebaseUser.email,
                        displayName: firebaseUser.displayName || firebaseUser.email?.split('@')[0],
                        photoURL: firebaseUser.photoURL,
                    }));
                }
            } else {
                dispatch(setUser(null));
            }

            dispatch(setLoading(false));
        }, (error) => {
            console.error('Auth state change error:', error);
            dispatch(setUser(null));
            dispatch(setLoading(false));
        });

        return () => unsubscribe();
    }, [dispatch]);
};